module.exports = __webpack_public_path__ + "img/sidebar_bundesliga_202627.0fd5d1e1.png";